import { createFileRoute } from "@tanstack/react-router";
import { ShutdownPage, shutdownHead } from "@/pages/ShutdownPage";

export const Route = createFileRoute("/de/shutdown-planung")({
  head: () => shutdownHead("de"),
  component: () => <ShutdownPage locale="de" />,
});
